<div
	role="button"
	tabindex="0"
	on:click
	on:keypress
	class="cursor-pointer border rounded-full border-gray-50 w-10 h-10 justify-items-center items-center mx-1"
>
	<slot />
</div>
